import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SiteProvider } from "./context/SiteContext";
import PrivateRoute from "./components/PrivateRoute";
import Header from "./components/Header";
import Footer from "./components/Footer";

// Public Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Authorcorner from "./pages/Authorcorner";
import Mentalhealthresources from "./pages/Mentalhealthresources";
import Termsandconditions from "./pages/Termsandconditions";
import SelfCare from "./pages/SelfCare";
import Refund from "./pages/Refund";
import Disclaimer from "./pages/Disclaimer";
import Privacy from "./pages/Privacy";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import CustomPage from "./pages/CustomPage";

// Admin Pages
import AdminLogin from "./admin/pages/AdminLogin";
import Dashboard from "./admin/pages/Dashboard";
import Products from "./admin/pages/Products";
import ProductCategories from "./admin/pages/ProductCategories";
import Blogs from "./admin/pages/Blogs";
import BlogCategories from "./admin/pages/BlogCategories";
import AdminEvents from "./admin/pages/Events";
import SiteSettings from "./admin/pages/SiteSettings";
import AdminProfile from "./admin/pages/AdminProfile";
import Pages from "./admin/pages/Pages";
import NavigationManager from "./admin/pages/NavigationManager";
import HomeContent from "./admin/pages/HomeContent";
import SelfCareContent from "./admin/pages/SelfCareContent";
import AboutContent from "./admin/pages/AboutContent";
import AuthorCornerContent from "./admin/pages/AuthorCornerContent";
import ContactForms from "./admin/pages/ContactForms";
import BookStore from "./admin/pages/BookStore";
import EBooks from "./admin/pages/EBooks";

import "./App.css";

// Layout wrapper for public pages
const PublicLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col">
    <Header />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <Router>
          <Routes>
            {/* ───── PUBLIC ───── */}
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
            <Route path="/author-corner" element={<PublicLayout><Authorcorner /></PublicLayout>} />
            <Route path="/mental-health-resources" element={<PublicLayout><Mentalhealthresources /></PublicLayout>} />
            <Route path="/self-care" element={<PublicLayout><SelfCare /></PublicLayout>} />
            <Route path="/refund" element={<PublicLayout><Refund /></PublicLayout>} />
            <Route path="/disclaimer" element={<PublicLayout><Disclaimer /></PublicLayout>} />
            <Route path="/privacy" element={<PublicLayout><Privacy /></PublicLayout>} />
            <Route path="/terms-and-conditions" element={<PublicLayout><Termsandconditions /></PublicLayout>} />
            <Route path="/shop" element={<PublicLayout><Shop /></PublicLayout>} />
            <Route path="/product/:id" element={<PublicLayout><ProductDetail /></PublicLayout>} />
            <Route path="/blog" element={<PublicLayout><Blog /></PublicLayout>} />
            <Route path="/blog/:id" element={<PublicLayout><BlogDetail /></PublicLayout>} />
            <Route path="/events" element={<PublicLayout><Events /></PublicLayout>} />
            <Route path="/event/:id" element={<PublicLayout><EventDetail /></PublicLayout>} />
            {/* Dynamic custom pages created by admin */}
            <Route path="/page/:slug" element={<PublicLayout><CustomPage /></PublicLayout>} />

            {/* ───── ADMIN ───── */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/admin/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/admin/products" element={<PrivateRoute><Products /></PrivateRoute>} />
            <Route path="/admin/product-categories" element={<PrivateRoute><ProductCategories /></PrivateRoute>} />
            <Route path="/admin/blogs" element={<PrivateRoute><Blogs /></PrivateRoute>} />
            <Route path="/admin/blog-categories" element={<PrivateRoute><BlogCategories /></PrivateRoute>} />
            <Route path="/admin/events" element={<PrivateRoute><AdminEvents /></PrivateRoute>} />
            <Route path="/admin/pages" element={<PrivateRoute><Pages /></PrivateRoute>} />
            <Route path="/admin/home" element={<PrivateRoute><HomeContent /></PrivateRoute>} />
            <Route path="/admin/self-care" element={<PrivateRoute><SelfCareContent /></PrivateRoute>} />
            <Route path="/admin/about" element={<PrivateRoute><AboutContent /></PrivateRoute>} />
            <Route path="/admin/author-corner" element={<PrivateRoute><AuthorCornerContent /></PrivateRoute>} />
            <Route path="/admin/contact-forms" element={<PrivateRoute><ContactForms /></PrivateRoute>} />
            <Route path="/admin/book-store" element={<PrivateRoute><BookStore /></PrivateRoute>} />
            <Route path="/admin/e-books" element={<PrivateRoute><EBooks /></PrivateRoute>} />
            <Route path="/admin/navigation" element={<PrivateRoute><NavigationManager /></PrivateRoute>} />
            <Route path="/admin/settings" element={<PrivateRoute><SiteSettings /></PrivateRoute>} />
            <Route path="/admin/profile" element={<PrivateRoute><AdminProfile /></PrivateRoute>} />

            {/* Catch-all */}
            <Route path="*" element={<PublicLayout><CustomPage /></PublicLayout>} />
          </Routes>
        </Router>
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;
